export default {
  campaigns: 'Campagnes',
  waves: 'Vagues',
  events: 'Evénements',
  challenges: 'Défis',
  wheel: 'Roue',
  libraries: 'Bibliothèques',
  banner: 'Bannière',
  contests: 'Concours',
  advices: 'Coach',
  customers: 'Utilisateurs',
  settings: 'Paramètres',
  surveys: 'Sondages',

  profil: 'Mon profil',
  signout: 'Déconnexion'
}



// WEBPACK FOOTER //
// ./src/translations/fr/menu.js